import { render, staticRenderFns } from "./BookingConfigurationClosedDates.vue?vue&type=template&id=091735a4"
import script from "./BookingConfigurationClosedDates.vue?vue&type=script&lang=ts"
export * from "./BookingConfigurationClosedDates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports